import React, { useState, useEffect, useRef } from 'react';
import './NavBarComponent.scss';
import { GoThreeBars, GoSignOut } from 'react-icons/go';
import { RiDashboardFill } from 'react-icons/ri';
import { RiCloseFill } from 'react-icons/ri';
import { FaUserCircle } from 'react-icons/fa';
import { Link } from 'react-scroll';
import firebase from 'firebase/app';
import Button from '../Button/Button';
import { useStateValue } from '../../services/ContextProvider';
import { roles, signIn, signOut } from '../../services/AuthService';
import { NavLink, useHistory } from 'react-router-dom';

const NavBarComponent = () => {

	//const [isMobileView, setisMobileView] = useState();
	const [menuHidden, setmenuHidden] = useState(true);
	const { userState, globalState, globleDispatch, userDispatch } = useStateValue();
	const [checkUser, setCheckUser] = useState(false);
	const [UserName, setUserName] = useState('');
	const [isScrolled, setisScrolled] = useState(false);
	const [signOutClicked, setsignOutClicked] = useState(false);
	const [photoUrl, setphotoUrl] = useState('');
	const [userEmail, setuserEmail] = useState('');
	const [isAdminPanel, setIsAdminPanel] = useState(false);
	const [isOutOfHome, setIsOutOfHome] = useState(false);
	const [userRole, setuserRole] = useState('');
	const signOutPopupRef = useRef(null);
	const history = useHistory();

	const checkScrolled = () => {
		if (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10) {
			setisScrolled(true);
		} else {
			setisScrolled(false);
		}
	};
	window.addEventListener('scroll', checkScrolled, { passive: true });


	useEffect(() => {
		if (history.location.pathname.includes('admin-panel'))
			setIsAdminPanel(true);
		if (history.location.pathname != '/')
			setIsOutOfHome(true);

		history.listen(() => {
			if (history.location.pathname.includes('admin-panel'))
				setIsAdminPanel(true);
			else
				setIsAdminPanel(false);
			if (history.location.pathname != '/')
				setIsOutOfHome(true);
			else setIsOutOfHome(false);

			console.log(history.location.pathname);
		});
	}, []);

	useEffect(() => {
		if (userState.loggedUserData) {
			setCheckUser(true);
			let { displayName, photoURL, email, role } = userState.loggedUserData;
			setUserName(displayName);
			setphotoUrl(photoURL);
			setuserEmail(email);
			setuserRole(role);
		} else {
			setCheckUser(false);
			setphotoUrl('');
			setuserEmail('');
			setUserName('');
			setuserRole('');
		}
	}, [userState]);

	function handleClickOutsideTheSignOut(event) {
		if (signOutPopupRef.current && !signOutPopupRef.current.contains(event.target)) {
			setsignOutClicked(false);
		}
	}

	useEffect(() => {
		if (signOutPopupRef !== null) {
			document.addEventListener('mousedown', handleClickOutsideTheSignOut);
			return () => {
				document.removeEventListener('mousedown', handleClickOutsideTheSignOut);
			};
		}
	}, [signOutPopupRef]);

	const handleLogin = async () => {
		console.log('login');
		await signIn();
	};

	const handleLogOut = async () => {
		setsignOutClicked(false);
		await signOut(globleDispatch, userDispatch);
	};

	const gotoAdminPanel = () => {
		setsignOutClicked(false);
		history.push('/admin-panel');
	};

	const NavLinkItem = ({ title, to }) => (
		<Link
			to={to}
			smooth={false}
			activeClass="link-active"
			offset={0}
			duration={500}
			delay={0}
			onClick={() => setmenuHidden(true)}
			spy={true}>{title}</Link>
	);

	if (isAdminPanel) {
		return (<></>);
	}

	return (
		<div className={`navBar-container ${isScrolled ? 'scrolled' : ''} ${isOutOfHome ? 'outHome' : ''} ${menuHidden ? '' : 'mobile-active'}`}>
			{menuHidden &&
				<div className="navBar-toggle-btn" onClick={() => setmenuHidden(false)}>
					<GoThreeBars />
				</div>
			}
			{!menuHidden &&
				<div className="navBar-toggle-btn" onClick={() => setmenuHidden(true)}>
					<RiCloseFill />
				</div>
			}
			<div className={
				menuHidden ?
					'navBar-nav-btn-section hide'
					: 'navBar-nav-btn-section'}
			>
				{isOutOfHome &&

					<NavLink to='/' style={{ textDecoration: 'none' }} onClick={() => setmenuHidden(true)}>
						<div className="navBar-go-back-to-home"><span>Go Back to Home</span></div>
					</NavLink>

				}
				{!isOutOfHome &&
					<div className="navBar-nav-btn-item">
						<NavLinkItem title="Home" to="home" />
					</div>
				}
				{!isOutOfHome &&
					<div className="navBar-nav-btn-item">
						<NavLinkItem title="About us" to="about-us" />
					</div>
				}
				{!isOutOfHome &&
					<div className="navBar-nav-btn-item">
						<NavLinkItem title="Our Projects" to="our-projects" />
					</div>
				}
				{!isOutOfHome &&
					<div className="navBar-nav-btn-item">
						<NavLinkItem title="Newsletter" to="newsletter" />
					</div>
				}
				{!isOutOfHome &&
					<div className="navBar-nav-btn-item">
						<NavLinkItem title="Contact us" to="contact-us" />
					</div>
				}


			</div>
			<div className="navBar-logo-section">
				<div className="navBar-logo mr-4">
					Leo Club of  <b>Colombo Monarch</b>
				</div>
				{
					!checkUser &&
					<div className="nav-item" style={{ cursor: 'pointer' }} onClick={handleLogin}>
						<span className="signin-icon mx-2"><FaUserCircle /></span> Login
					</div>
				}

				{
					checkUser &&
					<div className="nav-item signOut-btn" onClick={() => setsignOutClicked(true)}>
						<div className="" >
							<div className="nav-bar-pro-pic-icon">
								<img src={photoUrl} alt="" className="nav-bar-pro-pic" />
							</div>
							{/* {`${UserName.split(' ')[0]} ${UserName.split(' ')[1]}`}
							<div className="nav-item signOut-hide" >
								<span className="signin-icon"><GoSignOut /></span> Sign Out
							</div> */}
						</div>
					</div>
				}
				{signOutClicked && checkUser &&
					<div className='signOut-float-card' ref={signOutPopupRef}>
						<div className="signOut-float-image-section">
							<div className="signOut-float-image-container">
								<img src={photoUrl} alt={`${UserName.split(' ')[0]}`} className="signOut-float-img" />
							</div>
						</div>
						<div className="signOut-float-card-details-section">
							<div className="signOut-float-card-name">
								{UserName}
							</div>
							<div className="signOut-float-card-email">
								{userEmail}
							</div>
						</div>
						{userRole && userRole === roles.ADMIN &&
							<div onClick={gotoAdminPanel}>
								<div className="goto-admin-panel-btn">
									<span className='admin-panel-icon'><RiDashboardFill /></span>Go to Admin Panel
								</div>
							</div>
						}
						<div className="signOut-float-card-btn" onClick={handleLogOut}>
							<span className="signin-icon"><GoSignOut /></span> Sign Out
						</div>
					</div>
				}
			</div>
		</div>

	);

};

export default NavBarComponent;
